var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 58,
    viewBox: "0 0 84 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 12H0V45.5H7V32H12.5V27.2712H7V18H20V12Z",
    fill: "#F58866"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.744 38.664H45.56V45H26.12V11.4H32.744V38.664Z",
    fill: "#F58866"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M78.392 40.632C75 43.992 70.872 45.672 66.008 45.672C61.144 45.672 57.016 43.992 53.624 40.632C50.264 37.24 48.584 33.096 48.584 28.2C48.584 23.304 50.264 19.176 53.624 15.816C57.016 12.424 61.144 10.728 66.008 10.728C70.872 10.728 75 12.424 78.392 15.816C81.784 19.176 83.48 23.304 83.48 28.2C83.48 33.096 81.784 37.24 78.392 40.632ZM58.28 36.12C60.36 38.168 62.936 39.192 66.008 39.192C69.08 39.192 71.656 38.168 73.736 36.12C75.816 34.04 76.856 31.4 76.856 28.2C76.856 25 75.816 22.36 73.736 20.28C71.656 18.2 69.08 17.16 66.008 17.16C62.936 17.16 60.36 18.2 58.28 20.28C56.2 22.36 55.16 25 55.16 28.2C55.16 31.4 56.2 34.04 58.28 36.12Z",
    fill: "#F58866"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1471 29.3338C18.3 29.4599 18.3 29.6941 18.1471 29.8202L11.7682 35.0814C11.5627 35.2509 11.2525 35.1047 11.2525 34.8382L11.2525 24.3158C11.2525 24.0493 11.5627 23.9031 11.7682 24.0726L18.1471 29.3338Z",
    fill: "#E66A43"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7 27.2843H11.7682L11.6759 32.0975L7 32.0232V27.2843Z",
    fill: "#E66A43"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlo);
export default __webpack_public_path__ + "static/media/FLO.542e8eddecc92f6da43108814b754b4e.svg";
export { ForwardRef as ReactComponent };